<span class="click-container" style="z-index:100;position:relative;" (click)="captureNewValue($event)">
	<span class="stars {{ status }}" style="z-index: 80;">
		<span class="rating" [style.width]="stretch+'%'" style="z-index: 70;"></span>
	</span>
</span>
